import { useParams } from 'react-router-dom';
import { AccessProvider } from '../../../../contexts/accessProvider.tsx';
import { CategoryContextProvider } from '../../../../contexts/categories/category.tsx';
import { Role } from '../../../../models/enums/role.ts';
import CategoryBody from './body.tsx';
import CategoryHeader from './header.tsx';

const Category = () => {
    const { id } = useParams();
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <CategoryContextProvider id={id}>
                <CategoryHeader />
                <CategoryBody />
            </CategoryContextProvider>
        </AccessProvider>
    );
};

export default Category;
